import React from "react";

import {
  Admin,
  Resource,
  //   ShowGuesser,
  //   EditGuesser,
} from "react-admin";

import { myDataProvider } from "../dataProvider/dataProvider";
import reducer from "../reducer";

import customRoutes from "../routes";

import { CustomerLayout } from "./layout/CustomerLayout";
import { CustomerDashboard } from "./layout/CustomerDashboard";

// import { AccountEdit } from "../managerApp/resources/accounts/AccountEdit";
// import { AccountShow } from "../managerApp/resources/accounts/AccountShow";

import { InvoiceList } from "./resources/invoices/InvoiceList";
import { InvoiceShow } from "./resources/invoices/InvoiceShow";

import { InboundList } from "./resources/inbounds/InboundList";
import { InboundAdviceCreate } from "./resources/inbounds/InboundAdviceCreate";
import { InboundAdviceEdit } from "./resources/inbounds/InboundAdviceEdit";
import { InboundShow } from "./resources/inbounds/InboundShow";

import { OutboundList } from "./resources/outbounds/OutboundList";
import { OutboundAdviceCreate } from "./resources/outbounds/OutboundAdviceCreate";
import { OutboundAdviceEdit } from "./resources/outbounds/OutboundAdviceEdit";
import { OutboundShow } from "./resources/outbounds/OutboundShow";
// import { PickListItemEdit } from "../managerApp/resources/outboundShipments/lineItem/PickListItemEdit";

import { InventoryList } from "./resources/inventory/InventoryList";
// import { InventoryEdit } from "../managerApp/resources/inventory/InventoryEdit";
import { InventoryShow } from "./resources/inventory/InventoryShow";
// import { InventoryItemCreate } from '../managerApp/resources/inventory/inventoryItems/InventoryItemCreate';
// import { InventoryItemEdit } from '../managerApp/resources/inventory/inventoryItems/InventoryItemEdit';
import { InventoryItemShow } from "../managerApp/resources/inventory/inventoryItems/InventoryItemShow";

import { ProductCreate } from "../managerApp/resources/products/ProductCreate";
import { ProductEdit } from "../managerApp/resources/products/ProductEdit";
import { ProductList } from "./resources/products/ProductList";

import { TaskList } from "../managerApp/resources/tasks/TaskList";
import { TaskCreate } from "../managerApp/resources/tasks/TaskCreate";
import { TaskEdit } from "../managerApp/resources/tasks/TaskEdit";

import { CustomerList } from "./resources/customers/CustomerList";
// import { CustomerCreate } from "./resources/customers/CustomerCreate";
import { CustomerShow } from "./resources/customers/CustomerShow";
import { CustomerEdit } from "./resources/customers/CustomerEdit";

import { useThemeState } from "../ThemeStateProvider";

export const CustomerApp = ({ adminHistory }) => {
  const { selectedTheme } = useThemeState();

  return (
    <Admin
      disableTelemetry
      title="Transloads.co"
      dashboard={CustomerDashboard}
      options={{ authGroups: [] }}
      dataProvider={myDataProvider}
      layout={CustomerLayout}
      customRoutes={customRoutes}
      customReducers={{ data: reducer }}
      theme={selectedTheme}
      history={adminHistory}
    >
      <Resource
        title={"Inbound Shipments"}
        name="inboundShipments"
        list={InboundList}
        create={InboundAdviceCreate}
        edit={InboundAdviceEdit}
        show={InboundShow}
      />
      <Resource
        name="outboundShipments"
        list={OutboundList}
        create={OutboundAdviceCreate}
        edit={OutboundAdviceEdit}
        show={OutboundShow}
      />
      <Resource
        name="shipmentLineItems"
        // edit={PickListItemEdit}
      />
      <Resource
        name="inventories"
        list={InventoryList}
        show={InventoryShow}
        // edit={InventoryEdit}
      />
      <Resource
        name="inventoryItems"
        // create={InventoryItemCreate}
        // edit={InventoryItemEdit}
        show={InventoryItemShow}
      />
      <Resource name="accounts" />
      <Resource name="invoices" list={InvoiceList} show={InvoiceShow} />
      <Resource name="reloadYards" />
      <Resource name="services" />
      <Resource
        name="customers"
        list={CustomerList}
        // create={CustomerCreate}
        edit={CustomerEdit}
        show={CustomerShow}
      />
      <Resource
        title={"Tasks"}
        name="tasks"
        list={TaskList}
        create={TaskCreate}
        edit={TaskEdit}
      />
      <Resource
        title={"Product Catalog"}
        name="products"
        create={ProductCreate}
        edit={ProductEdit}
        list={ProductList}
      />
      <Resource name="areas" />
      <Resource name="zones" />
      <Resource name="locations" />
      <Resource name="capabilitys" />
      <Resource name="commoditys" />
      <Resource name="reloadYardCommoditys" />
      <Resource name="reloadYardCapabilitys" />
    </Admin>
  );
};
